define('utils',[
    'bootstrap',
    'ShareTools',
    'text!ShareTools/quizTemplate',
    'text!ShareTools/appTemplate'
], function (
    news,
    ShareTools,
    ShareToolsTemplate,
    ShareToolsAppTemplate
) {
    var utils = {};
    var shareTools;

    utils.getLangCodeFromServiceName = function (service) {
            var langDict = {},
                langCode = 'en-gb';

            langDict.news       = 'en-gb';
            langDict.afrique    = 'fr'; //not in our iSite list
            langDict.arabic     = 'ar';
            langDict.azeri      = 'az';
            langDict.bengali    = 'bn';
            langDict.brasil     = 'pt-BR';
            langDict.burmese    = 'my';
            langDict.chinese_simp = 'zh-Hans';
            langDict.chinese_trad = 'zh-Hant';
            langDict.cymru      = 'cy'; // not in our iSite list
            langDict.french     = 'fr';
            langDict.gahuza     = 'rw';
            langDict.hausa      = 'ha';
            langDict.hindi      = 'hi';
            langDict.indonesian = 'id';
            langDict.kyrgyz     = 'ky';
            langDict.mundo      = 'es';
            langDict.nepali     = 'ne';
            langDict.pashto     = 'ps';
            langDict.persian    = 'fa';
            langDict.pidgin     = 'pcm';
            langDict.russian    = 'ru';
            langDict.sinhali    = 'si';
            langDict.somali     = 'so';
            langDict.swahili    = 'sw';
            langDict.tajik      = 'tg'; //not in our iSite list
            langDict.tamil      = 'ta';
            langDict.turkish    = 'tr';
            langDict.ukranian   = 'uk';
            langDict.urdu       = 'ur';
            langDict.uzbek      = 'uz';
            langDict.vietnamese = 'vi';
            langDict.gujarati   = 'gu';
            langDict.igbo       = 'ig';
            langDict.korean     = 'ko';
            langDict.punjabi    = 'pa';
            langDict.telugu     = 'te';
            langDict.yoruba     = 'yo';
            langDict.amharic    = 'am';
            langDict.tigrinya   = 'ti';
            langDict.afaanoromoo  = 'om';
            langDict.marathi    = 'mr';
            langDict.thai       = 'th';
            langDict.serbian    = 'sr';


            if (typeof langDict[service] !== 'undefined' && langDict[service] !== ''){
                langCode = langDict[service];
            }
            return langCode;
    };

    utils.setupShare = function (vocabs, quizInAnIframe, iframeWrapper) {
        var url;

        url = utils.getQuizUrl(quizInAnIframe, iframeWrapper);

        news.pubsub.on('shareTools:message', function (message) {
            var messages = {
                facebook: {
                    title: message,
                    image: vocabs.facebookShareImg
                },
                twitter: message,
                email: {
                    subject: 'Shared from BBC News',
                    message: message
                },
                app: {
                    shareEndpoint: 'bbcnewsapp://visualjournalism/share',
                    popup: false,
                    properties: {
                        title: message,
                        text: 'Shared from BBC News'
                    }
                }
            };

            if (!shareTools) {
                var shareToolsConfig = {
                    holderEl: '.result-section__share-tools',
                    label: vocabs.shareHeader,
                    shareUrl: url,
                    messages: messages
                };
                shareToolsConfig.template = news.isInTheNewsApp ? ShareToolsAppTemplate : ShareToolsTemplate;
                shareTools = new ShareTools(shareToolsConfig);
            } else {
                shareTools.setMessages(messages);
            }

            shareTools.onShareButtonClick(function (network) {
                news.pubsub.emit('quiz:istatsCall', ['quiz-share-' + network]);
            });
        });
    };

    utils.getQueryStringValue = function (key) {
        return unescape(window.location.search.replace(new RegExp("^(?:.*[&\\?]" + escape(key).replace(/[\.\+\*]/g, "\\$&") + "(?:\\=([^&]*))?)?.*$", "i"), "$1")); // jshint ignore:line
    };

    utils.cutsTheMustard = function () {
        var modernDevice =
            'querySelector' in document &&
            'localStorage' in window &&
            'addEventListener';

        return modernDevice;
    };

    utils.getQuizUrl = function (quizInAnIframe, iframeWrapper) {
        var url;

        url = window.location.href;

        if (quizInAnIframe && iframeWrapper) {
            url = JSON.parse(iframeWrapper.url()).hostInformation.hostUrl;
        }

        return url;
    };

    utils.htmlEntitiesEncode = function (string){
        var el = document.createElement('div'),
        encodedString;

        el.innerText  = el.textContent = string;
        encodedString = el.innerHTML;

        return encodedString;
    };

  return utils;
});

